import { render, staticRenderFns } from "./statuses.vue?vue&type=template&id=97fb525c"
import script from "./statuses.vue?vue&type=script&lang=js"
export * from "./statuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports